import { render } from "./ImageSlideshow.vue?vue&type=template&id=61b8e498"
import script from "./ImageSlideshow.vue?vue&type=script&lang=js"
export * from "./ImageSlideshow.vue?vue&type=script&lang=js"

import "./ImageSlideshow.vue?vue&type=style&index=0&id=61b8e498&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__